import axios from 'axios';
let baseURL = 'https://simplifyed.io/dev-api/class';

export const Post = (endPoints, reqContent) => {
  return axios.post(baseURL + endPoints, reqContent);
};

export const Get = (endPoints) => {
  return axios.get(baseURL + endPoints);
};

export const GetWithToken = (endPoints) => {
  const access_token = JSON.parse(localStorage.getItem('user'))['message'].access_token;
  const header = {
    headers: { Authorization: `Bearer ${access_token}` },
  };
  return axios.get(baseURL + endPoints, header);
};

export const PostWithToken = (endPoints, reqContent) => {
  const access_token = JSON.parse(localStorage.getItem('user'))['message'].access_token;
  const header = {
    headers: { Authorization: `Bearer ${access_token}` },
  };
  return axios.post(baseURL + endPoints, reqContent, header);
};

export const uploadWithToken = (endPoints, reqContent) => {
  const access_token = JSON.parse(localStorage.getItem('user'))['message'].access_token;
  const header = {
    headers: { Authorization: `Bearer ${access_token}`, 'Content-Type': undefined },
  };
  return axios.post(baseURL + endPoints, reqContent, header);
};